function padLeft(str, len) {
	str = '' + str;
	return str.length >= len ? str : new Array(len - str.length + 1).join("0") + str;
}


function selectSetColor(e) {
	if (e.value != '') {
		$(e).removeClass("is-empty")
	} else {
		$(e).addClass("is-empty")
	}
}


function reloadImg() {
	let sNewUrl = $("#rand-img").attr("src") + "?rnd=" + Math.random();
	$("#rand-img").attr("src", sNewUrl);
}



export {
	padLeft,
	selectSetColor,
	reloadImg,
}